import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-498b61e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sa-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "sa-page-title" }, "Super-Administration", -1))
const _hoisted_3 = { class: "sa-subnav" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "sa-title" }, "Unterweisungen (Vorlagen)"),
  /*#__PURE__*/_createElementVNode("p", { class: "sa-subtitle" }, "Standard-Unterweisungen aus mehreren benannten PDFs anlegen und für Einrichtungen veröffentlichen")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "sa-loading"
}
const _hoisted_6 = {
  key: 1,
  class: "sa-error"
}
const _hoisted_7 = {
  key: 2,
  class: "sa-card"
}
const _hoisted_8 = { class: "sa-table" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Unterweisung"),
    /*#__PURE__*/_createElementVNode("th", null, "Dokumente"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Aktionen")
  ])
], -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "sa-empty"
}, "Noch keine Vorlagen angelegt.", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "sa-course-title" }
const _hoisted_14 = { class: "sa-actions" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
], -1))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "2",
    y1: "12",
    x2: "22",
    y2: "12"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" })
], -1))
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
], -1))
const _hoisted_21 = { class: "sa-modal" }
const _hoisted_22 = { class: "il-field" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "il-label" }, [
  /*#__PURE__*/_createTextVNode("Name der Unterweisung "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_24 = { class: "il-field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "il-label" }, "Dokumente", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "il-hint" }, "Jedes PDF bekommt einen Namen, der Einrichtungen und Mitarbeitenden angezeigt wird.", -1))
const _hoisted_27 = ["onDragover", "onDrop"]
const _hoisted_28 = ["onDragstart"]
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<svg width=\"10\" height=\"16\" viewBox=\"0 0 10 16\" fill=\"currentColor\" aria-hidden=\"true\" data-v-498b61e0><circle cx=\"2.5\" cy=\"3\" r=\"1.3\" data-v-498b61e0></circle><circle cx=\"7.5\" cy=\"3\" r=\"1.3\" data-v-498b61e0></circle><circle cx=\"2.5\" cy=\"8\" r=\"1.3\" data-v-498b61e0></circle><circle cx=\"7.5\" cy=\"8\" r=\"1.3\" data-v-498b61e0></circle><circle cx=\"2.5\" cy=\"13\" r=\"1.3\" data-v-498b61e0></circle><circle cx=\"7.5\" cy=\"13\" r=\"1.3\" data-v-498b61e0></circle></svg>", 1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = { class: "il-doc-file" }
const _hoisted_33 = { class: "il-doc-actions" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "15 3 21 3 21 9" }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "10",
    y1: "14",
    x2: "21",
    y2: "3"
  })
], -1))
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
], -1))
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+ PDF hinzufügen", -1))
const _hoisted_40 = { class: "il-check" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Für Einrichtungen veröffentlichen (als Vorlage verfügbar)", -1))
const _hoisted_42 = {
  key: 0,
  class: "il-error"
}
const _hoisted_43 = { class: "sa-modal-actions" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "sa-modal" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Unterweisung löschen", -1))
const _hoisted_47 = {
  key: 0,
  class: "il-error"
}
const _hoisted_48 = { class: "sa-modal-actions" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]

import { ref, computed, onMounted } from 'vue';
import { useStore } from '@/store';
import DotMenu from '@/components/DotMenu.vue';
import type { Instruction } from '@/store/instructionLibrary';

interface DocRow { contentId: string | null; title: string; origTitle: string; fileName: string; file: File | null }


export default /*#__PURE__*/_defineComponent({
  __name: 'InstructionLibraryView',
  setup(__props) {

const ACCEPT = 'application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document';

const store = useStore();

const loading = ref(true);
const error = ref('');

const templates = computed<Instruction[]>(() => store.getters['instructionLibrary/getTemplates']);

onMounted(async () => {
  try {
    await Promise.all([
      store.dispatch('instructionLibrary/LOAD_TEMPLATES', { force: true }),
      store.dispatch('instructionLibrary/LOAD', { force: true }),
    ]);
  } catch (e) {
    error.value = 'Die Unterweisungen konnten nicht geladen werden.';
  } finally {
    loading.value = false;
  }
});

// ── Anlegen / Bearbeiten ──────────────────────────────────
const modalVisible = ref(false);
const editing = ref<Instruction | null>(null);
const saving = ref(false);
const modalError = ref('');

const form = ref<{ title: string; published: boolean }>({ title: '', published: false });
const docs = ref<DocRow[]>([]);

function openCreate() {
  editing.value = null;
  form.value = { title: '', published: false };
  docs.value = [];
  modalError.value = '';
  modalVisible.value = true;
}

function openEdit(t: Instruction) {
  editing.value = t;
  form.value = { title: t.title, published: t.published === true };
  docs.value = [...(t.sections || [])]
    .sort((a, b) => a.order - b.order)
    .map((s) => {
      const title = store.getters['instructionLibrary/getContentTitle'](s.contentId) || 'Dokument';
      return { contentId: s.contentId, title, origTitle: title, fileName: '', file: null };
    });
  modalError.value = '';
  modalVisible.value = true;
}

function onAddDoc(e: Event) {
  const target = e.target as HTMLInputElement;
  const file = target.files && target.files[0];
  if (file) {
    const name = file.name.replace(/\.[^.]+$/, '');
    docs.value.push({ contentId: null, title: name, origTitle: '', fileName: file.name, file });
  }
  target.value = '';
}

// Reihenfolge der Dokumente: Drag & Drop (Maus) plus ↑/↓ (Tastatur).
const dragIndex = ref<number | null>(null);
const dragOverIndex = ref<number | null>(null);

function move(from: number, to: number) {
  if (to < 0 || to >= docs.value.length || from === to) return;
  const arr = docs.value.slice();
  const [moved] = arr.splice(from, 1);
  arr.splice(to, 0, moved);
  docs.value = arr;
}
function onDragStart(idx: number) {
  dragIndex.value = idx;
}
function onDrop(idx: number) {
  if (dragIndex.value !== null) move(dragIndex.value, idx);
  dragIndex.value = null;
  dragOverIndex.value = null;
}
function onDragEnd() {
  dragIndex.value = null;
  dragOverIndex.value = null;
}

async function save() {
  modalError.value = '';
  if (!form.value.title.trim()) {
    modalError.value = 'Bitte geben Sie einen Namen ein.';
    return;
  }
  if (!docs.value.length) {
    modalError.value = 'Bitte fügen Sie mindestens ein Dokument hinzu.';
    return;
  }
  if (docs.value.some((d) => !d.title.trim())) {
    modalError.value = 'Bitte benennen Sie jedes Dokument.';
    return;
  }

  saving.value = true;
  try {
    const sections: { contentId: string; contentOrg: string; order: number }[] = [];
    for (let i = 0; i < docs.value.length; i++) {
      const d = docs.value[i];
      let contentId = d.contentId;
      if (!contentId && d.file) {
        // Neues MEDA-Dokument: als veröffentlichter Baustein anlegen (einzeln wählbar für Einrichtungen).
        const content = await store.dispatch('instructionLibrary/CREATE_WITH_FILE', {
          title: d.title.trim(),
          file: d.file,
          confirmationItems: ['Inhalt gelesen und verstanden'],
          published: true,
        });
        contentId = content.contentId;
      } else if (contentId && d.title.trim() !== d.origTitle) {
        await store.dispatch('instructionLibrary/UPDATE', {
          contentId,
          payload: { title: d.title.trim() },
        });
      }
      if (contentId) sections.push({ contentId, contentOrg: 'MEDA', order: i });
    }

    if (editing.value) {
      await store.dispatch('instructionLibrary/UPDATE_TEMPLATE', {
        instructionId: editing.value.instructionId,
        payload: { title: form.value.title.trim(), sections, published: form.value.published },
      });
    } else {
      await store.dispatch('instructionLibrary/CREATE_TEMPLATE', {
        title: form.value.title.trim(),
        ownerType: 'MEDA',
        published: form.value.published,
        sections,
      });
    }
    modalVisible.value = false;
  } catch (e: any) {
    modalError.value = e?.response?.data?.error || 'Beim Speichern ist ein Fehler aufgetreten.';
  } finally {
    saving.value = false;
  }
}

async function togglePublish(t: Instruction) {
  try {
    await store.dispatch('instructionLibrary/UPDATE_TEMPLATE', {
      instructionId: t.instructionId,
      payload: { published: !t.published },
    });
  } catch (e) {
    window.alert('Status konnte nicht geändert werden.');
  }
}

const deleteTarget = ref<Instruction | null>(null);
const deleting = ref(false);
const deleteError = ref('');

function doDelete(t: Instruction) {
  deleteError.value = '';
  deleteTarget.value = t;
}

async function confirmDelete() {
  if (!deleteTarget.value) return;
  deleting.value = true;
  deleteError.value = '';
  try {
    await store.dispatch('instructionLibrary/DELETE_TEMPLATE', deleteTarget.value.instructionId);
    deleteTarget.value = null;
  } catch (e) {
    deleteError.value = 'Löschen fehlgeschlagen. Bitte versuchen Sie es erneut.';
  } finally {
    deleting.value = false;
  }
}

// Dokument in neuem Tab ansehen. Bereits gespeicherte Bausteine über pre-signed URL,
// noch nicht gespeicherte Uploads über eine lokale Object-URL.
async function openDoc(d: DocRow) {
  if (!d.contentId) {
    if (d.file) window.open(URL.createObjectURL(d.file), '_blank');
    return;
  }
  const w = window.open('', '_blank');
  try {
    const res = await store.dispatch('instructionLibrary/GET_DOC_URL', { contentId: d.contentId });
    if (w && res && res.url) w.location.href = res.url;
    else if (w) w.close();
  } catch (e) {
    if (w) w.close();
    window.alert('Dokument konnte nicht geöffnet werden.');
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/superadmin/organisations",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Organisationen")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/superadmin/courses",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Kurse")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/superadmin/instruction-library",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Unterweisungen")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", { class: "sa-header" }, [
      _hoisted_4,
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: openCreate
      }, "+ Neue Unterweisung")
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Wird geladen …"))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (!_unref(templates).length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_10, _hoisted_12))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templates), (t) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: t.instructionId
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(t.title), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString((t.sections || []).length) + " PDF(s)", 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['status-badge', t.published ? 'status-published' : 'status-draft'])
                      }, _toDisplayString(t.published ? 'Veröffentlicht' : 'Entwurf'), 3)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(DotMenu, null, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "dot-menu-item",
                              onClick: ($event: any) => (openEdit(t))
                            }, [
                              _hoisted_16,
                              _createTextVNode(" Bearbeiten ")
                            ], 8, _hoisted_15),
                            _createElementVNode("button", {
                              class: "dot-menu-item",
                              onClick: ($event: any) => (togglePublish(t))
                            }, [
                              _hoisted_18,
                              _createTextVNode(" " + _toDisplayString(t.published ? 'Zurückziehen' : 'Veröffentlichen'), 1)
                            ], 8, _hoisted_17),
                            _createElementVNode("button", {
                              class: "dot-menu-item danger",
                              onClick: ($event: any) => (doDelete(t))
                            }, [
                              _hoisted_20,
                              _createTextVNode(" Löschen ")
                            ], 8, _hoisted_19)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])),
    (modalVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "sa-modal-backdrop",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (modalVisible.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("h3", null, _toDisplayString(editing.value ? 'Unterweisung bearbeiten' : 'Neue Unterweisung'), 1),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event)),
                class: "il-input",
                type: "text",
                placeholder: "z. B. Datenschutz"
              }, null, 512), [
                [_vModelText, form.value.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _hoisted_26,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(docs.value, (d, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: _normalizeClass(["il-doc-row", { dragover: dragOverIndex.value === idx }]),
                  onDragover: _withModifiers(($event: any) => (dragOverIndex.value = idx), ["prevent"]),
                  onDragleave: _cache[1] || (_cache[1] = ($event: any) => (dragOverIndex.value = null)),
                  onDrop: ($event: any) => (onDrop(idx))
                }, [
                  _createElementVNode("span", {
                    class: "il-drag",
                    draggable: "true",
                    title: "Ziehen zum Sortieren",
                    onDragstart: ($event: any) => (onDragStart(idx)),
                    onDragend: onDragEnd
                  }, _hoisted_30, 40, _hoisted_28),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((d.title) = $event),
                    class: "il-input",
                    type: "text",
                    placeholder: "Dokumentname"
                  }, null, 8, _hoisted_31), [
                    [_vModelText, d.title]
                  ]),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(d.fileName || 'vorhanden'), 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(DotMenu, null, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "dot-menu-item",
                          onClick: ($event: any) => (openDoc(d))
                        }, [
                          _hoisted_35,
                          _createTextVNode(" Vorschau ")
                        ], 8, _hoisted_34),
                        _createElementVNode("button", {
                          class: "dot-menu-item danger",
                          onClick: ($event: any) => (docs.value.splice(idx, 1))
                        }, [
                          _hoisted_37,
                          _createTextVNode(" Entfernen ")
                        ], 8, _hoisted_36)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ], 42, _hoisted_27))
              }), 128)),
              _createElementVNode("label", {
                class: _normalizeClass(["il-filedrop", { uploading: saving.value }])
              }, [
                _createElementVNode("input", {
                  type: "file",
                  accept: ACCEPT,
                  disabled: saving.value,
                  onChange: onAddDoc
                }, null, 40, _hoisted_38),
                _hoisted_39
              ], 2)
            ]),
            _createElementVNode("label", _hoisted_40, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.published) = $event))
              }, null, 512), [
                [_vModelCheckbox, form.value.published]
              ]),
              _hoisted_41
            ]),
            (modalError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(modalError.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (modalVisible.value = false))
              }, "Abbrechen"),
              _createElementVNode("button", {
                class: "btn btn-primary",
                disabled: saving.value,
                onClick: save
              }, _toDisplayString(saving.value ? 'Wird gespeichert …' : 'Speichern'), 9, _hoisted_44)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (deleteTarget.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "sa-modal-backdrop",
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (deleteTarget.value = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            _createElementVNode("p", null, "Soll die Unterweisung „" + _toDisplayString(deleteTarget.value.title) + "\" wirklich gelöscht werden? Das lässt sich nicht rückgängig machen.", 1),
            (deleteError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(deleteError.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                disabled: deleting.value,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (deleteTarget.value = null))
              }, "Abbrechen", 8, _hoisted_49),
              _createElementVNode("button", {
                class: "btn btn-danger-solid",
                disabled: deleting.value,
                onClick: confirmDelete
              }, _toDisplayString(deleting.value ? 'Wird gelöscht …' : 'Löschen'), 9, _hoisted_50)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})